import React, { useMemo, useState } from 'react'
import CheckboxOption from './CheckboxOption'
import PanelFooter from './PanelFooter'
import PanelHead from './PanelHead'
import useStagedSelection from '../useStagedSelection'

// Reads facet counts from `model.results.results.groups.cause`,
// applied state from `model.filters.orgs.selected.causes`.
// No locked equivalent today (per FiltersApplied.jsx — causes pass {} as locked).

export default function CausePanel({ model, changeState, search, onClose }) {
  const applied = (model.filters.orgs && model.filters.orgs.selected && model.filters.orgs.selected.causes) || {}
  const groups = (model.results && model.results.results && model.results.results.groups) || {}
  const facets = groups.cause || {}

  const [query, setQuery] = useState('')

  const { staged, toggle, reset, apply } = useStagedSelection({
    applied,
    locked: {},
    model,
    changeState,
    search,
    onClose,
    commit: (updated, stagedMap) => {
      if (!updated.filters.orgs.selected) updated.filters.orgs.selected = {}
      updated.filters.orgs.selected.causes = { ...stagedMap }
      updated.filters.orgs.causes_on = false
    },
  })

  const options = useMemo(() => {
    const q = query.trim().toLowerCase()
    return Object.keys(facets)
      .filter((name) => !q || name.toLowerCase().includes(q))
      .map((name) => ({ name, count: facets[name] }))
  }, [facets, query])

  return (
    <>
      <PanelHead title="Filter by Cause" placeholder="Search causes" query={query} onQuery={setQuery} />
      <div className="fb-menu-list">
        {options.length === 0 && (
          <p className="fb-menu-empty">
            {query ? 'No causes match' : 'No causes available'}
          </p>
        )}
        {options.map((opt) => (
          <CheckboxOption
            key={opt.name}
            label={opt.name}
            count={opt.count}
            checked={!!staged[opt.name]}
            onToggle={() => toggle(opt.name)}
          />
        ))}
      </div>
      <PanelFooter onReset={reset} onApply={apply} />
    </>
  )
}
